import type { App } from 'vue'

interface Options {
  name?: string
}

function install(app: App, options: Options = {}) {
  /**
   * 检测图片是否存在
   * @param url
   */
  const imageIsExist = function (url: string) {
    return new Promise((resolve) => {
      let img: HTMLImageElement | null = new Image()
      img.onload = function () {
        if ((this as HTMLImageElement).complete === true) {
          resolve(true)
          img = null
        }
      }
      img.onerror = function () {
        resolve(false)
        img = null
      }
      img.src = url
    })
  }
  app.directive(options.name || 'default-img', async function (el, binding) {
    // 指令名称为：v-default-img
    const imgURL = el.src // 获取图片地址
    const defaultURL = binding.value // 如果想要指定图片用到这个地方，下面的img也要同时改动
    if (imgURL) {
      const exist = await imageIsExist(imgURL)
      if (exist) {
        el.setAttribute('src', imgURL)
      } else {
        el.setAttribute('src', defaultURL)
      }
    } else {
      el.setAttribute('src', defaultURL)
    }
  })
}

const defaultImgPlugin = {
  install
}

export function setUpDefaultImg(app: App, options: Options = {}) {
  app.use(defaultImgPlugin, options)
}

export default defaultImgPlugin
